import { ApplicationError } from '@/src/shared/errors';

export class GetOutletServicesFailedError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Gagal memuat data layanan silahkan coba beberapa saat lagi'
    );
  }
}

export class GetOutletProductsFailedError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal memuat data produk silahkan coba beberapa saat lagi');
  }
}

export class BookServiceFailedError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Gagal memproses booking layanan, silahkan coba beberapa saat lagi'
    );
  }
}

export class ServiceSlotNotFoundError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Layanan tidak ditemukan, silahkan cek kembali layanan yang Anda pilih'
    );
  }
}

export class ServiceSlotExistsError extends ApplicationError {
  constructor() {
    super('Error', 'Layanan sudah ada, silahkan pilih slot lain');
  }
}
